import React from 'react';

export type StatusVariant = 'success' | 'warning' | 'danger' | 'neutral' | 'info';

interface StatusBadgeProps {
  status: string;
  variant?: StatusVariant;
  size?: 'sm' | 'md';
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  variant = 'neutral',
  size = 'sm',
}) => {
  const variantStyles: Record<StatusVariant, string> = {
    success: 'bg-emerald-950/60 text-emerald-400 border-emerald-800/80',
    warning: 'bg-amber-950/60 text-amber-400 border-amber-800/80',
    danger: 'bg-rose-950/60 text-rose-400 border-rose-800/80',
    info: 'bg-sky-950/60 text-sky-400 border-sky-800/80',
    neutral: 'bg-zinc-800/80 text-zinc-300 border-zinc-700/80',
  };

  const sizeStyles = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-sm px-2.5 py-1',
  };

  return (
    <span
      className={`inline-flex items-center gap-1.5 font-mono font-medium rounded border ${variantStyles[variant]} ${sizeStyles[size]}`}
    >
      <span
        className={`w-1.5 h-1.5 rounded-full ${
          variant === 'success'
            ? 'bg-emerald-400'
            : variant === 'warning'
            ? 'bg-amber-400'
            : variant === 'danger'
            ? 'bg-rose-400'
            : variant === 'info'
            ? 'bg-sky-400'
            : 'bg-zinc-400'
        }`}
      />
      {status}
    </span>
  );
};

